import { IReservationRequiredFieldProps, isEmailRequired, isNameRequired, isPhoneNumberRequired } from 'src/entities/reservation';
import { IReservationEndUser, IUser, IUserInvoice } from 'src/entities/user';
import FormValidator from 'src/services/formValidator';
import { invoiceDetailsRules } from 'src/services/validations/invoiceDetailsRules';
import { reservationEndRules } from 'src/services/validations/reservationEndRules';

export const createUserInvoice = (actUser?: IUser | null): IUserInvoice => {
    if (actUser && actUser.InvoiceDetails) {
        return actUser.InvoiceDetails;
    }

    return {
        InvoiceName: '',
        Country: '',
        City: '',
        StreetAddress: '',
        PostalCode: '',
        PrivatePerson: false,
        TaxNumber: ''
    }
}

export const createReservationEndUser = (actUser: IUser | null): IReservationEndUser => {
    if (actUser) {
        if (!actUser.InvoiceDetails) {
            actUser.InvoiceDetails = createUserInvoice();
        }
        const { Email, Name, Phone, InvoiceDetails, PrivacyStatementAccepted } = actUser;
        return { Email, Name, Phone, InvoiceDetails, PrivacyStatementAccepted, TermsAccepted: false };
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const nameParam = urlSearchParams.get('name');
    const emailParam = urlSearchParams.get('email');
    const phoneParam = urlSearchParams.get('phone');

    return {
        Email: emailParam || '',
        Name: nameParam || '',
        Phone: phoneParam || '',
        PrivacyStatementAccepted: false,
        InvoiceDetails: createUserInvoice(actUser),
        TermsAccepted: false
    }
}

export const createValidator = (props: IReservationRequiredFieldProps, shouldSignUp: boolean, isTermsRequired: boolean) => {
    return {
        personalValidator: new FormValidator(
            reservationEndRules(
                shouldSignUp || isEmailRequired(props),
                shouldSignUp || isPhoneNumberRequired(props),
                shouldSignUp || isNameRequired(props),
                isTermsRequired)),
        invoiceValidator: new FormValidator(invoiceDetailsRules())
    };
}

export const createValidation = (actValidator: FormValidator, data: any, submitted: boolean) => {
    return submitted
        ? actValidator.validate(data)
        : actValidator.getInitial();
}